module.exports = __webpack_public_path__ + "static/media/building_4.097c719f.jpg";